import React from 'react'
import ItemLegendCycle from '../ItemLegendCycle/ItemLegendCycle';

type ComponentProps = {
  list: {
    color: string;
    name: string;
  }[],
  cycleControllersName: {
    [key: string]: string;
  },
  nameDevices: {
    [key: string]: string;
  }
  channelsToHide: string[];
}

const ListLegendsCycle: React.FC<ComponentProps> = ({
  list,
  cycleControllersName,
  nameDevices,
  channelsToHide,
}) => {
  return (
    <div className="c-cycle-chart-preview__legend-wrapper pb-10 ">
      <ul className="c-cycle-chart-preview__legend flex w-full flex-row flex-wrap gap-x-3 gap-y-2 rounded-md bg-white p-5">
        {list.map((item) => (
          <ItemLegendCycle
            key={item.name}
            data={item}
            cycleControllersName={cycleControllersName}
            deviceName={nameDevices ? nameDevices[item.name] : ''}
            isHide={channelsToHide.includes(item.name)}
          />
        ))}
      </ul>
    </div>
  )
};

export default ListLegendsCycle;